import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';

import { Table }                               from '../table/types/table';
import { TableColumn }                         from '../table/types/table-column';
import { TableSwitchControlComponent }         from '../table/cell-components/controls/switch-control/table-switch-control.component';
import { VehicleRegistrationBrakeModel }       from './typings/vehicle-registration.brake';
import { VehicleRegistrationTireDetailsModel } from './typings/vehicle-registration.tire-details';
import { VehicleRegistrationTireSectionModel } from './typings/vehicle-registration.tire-section';
import { VehicleRegistrationWheelModel }       from './typings/vehicle-registration.wheel';

@Component({
  selector   : 'wor-vehicle-registration-tire',
  template: require('./vehicle-registration.tire.component.html')
})
export class VehicleRegistrationTireComponent implements OnInit {
  @Input() tire: VehicleRegistrationTireSectionModel = {} as VehicleRegistrationTireSectionModel;

  brakes : Array<VehicleRegistrationBrakeModel>       = [];
  tires  : Array<VehicleRegistrationTireDetailsModel> = [];
  wheels : Array<VehicleRegistrationWheelModel>       = [];

  brakeTableSettings: Table = {
    columns   : [],
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  tireTableSettings: Table = {
    columns   : [],
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  wheelTableSettings: Table = {
    columns   : [],
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.buildData();
  }

  buildData () : void {
    this.brakes = [ this.tire.Brakes ];
    this.tires  = [ this.tire.Tyres ];
    this.wheels = [ this.tire.Wheels ];

    this.brakeTableSettings.columns = this.filterColumns(this.tire.Brakes, [
        {
          field : 'BrakeType',
          header: {
            text: this.translateService.instant('VEHICLE_SPACE.BRAKE_TYPE')
          }
        },
        {
          field : 'CaliperType',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.CALIPER_TYPE')
          }
        }
      ]);

    this.tireTableSettings.columns = this.filterColumns(this.tire.Tyres, [
        {
          field : 'FullDescription',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.SIZE')
          }
        },
        {
          field : 'PressureMin',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.MIN_PRESSURE')
          }
        },
        {
          field : 'PressureMax',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.MAX_PRESSURE')
          }
        },
        {
          field : 'SectionWidth',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.SECTION_WIDTH')
          }
        },
        {
          field : 'AspectRatio',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.ASPECT_RATIO')
          }
        },
        {
          field : 'InternalConstruction',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.INTERNAL_CONSTRUCTION')
          }
        },
        {
          field : 'LoadIndex',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.LOAD_INDEX')
          }
        },
        {
          field : 'SpeedIndex',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.SPEED_INDEX')
          }
        },
        {
          field : 'OverallDiameter',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.OVERALL_DIAMETER')
          }
        },
        {
          field : 'FitmentType',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.FITMENT_TYPE')
          }
        }
      ]);

    this.tireTableSettings.columns.push({
      classes  : 'text-center',
      component: {
        bindings: {
          inputs: {
            disabled: true,
            model   : 'RunFlat',
            name    : 'RunFlat'
          }
        },
        enabled: true,
        factory: TableSwitchControlComponent
      },
      field : 'RunFlat',
      header: {
        classes: 'text-center',
        text   : this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.RUN_FLAT')
      }
    });

    this.wheelTableSettings.columns = this.filterColumns(this.tire.Wheels, [
        {
          field : 'Description',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
          }
        },
        {
          field : 'RimDiameter',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.RIM_DIAMETER')
          }
        },
        {
          field : 'RimWidth',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.RIM_WIDTH')
          }
        },
        {
          field : 'HubDiameter',
          header: {
            text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VEHICLE_REGISTRATIONS.HUB_DIAMETER')
          }
        },
        {
          field : 'Offset',
          header: {
            text: this.translateService.instant('REPORT_SPACE.FIELD.OFFSET')
          }
        }
      ]);
  }

  filterColumns ( data : VehicleRegistrationBrakeModel | VehicleRegistrationTireDetailsModel | VehicleRegistrationWheelModel, columns: Array<TableColumn> ) : Array<TableColumn> {
    return columns.filter(column => column.field
        && data[ column.field ] !== null
        && data[ column.field ] !== undefined
        && data[ column.field ] !== ''
      );
  }

}
